module.exports = "../static/images/aa45f4.png";